// Stampa diretta ESC/POS su stampanti termiche via WebUSB / Web Bluetooth
const KEY = "menuone_printer";
const ESC = 0x1b, GS = 0x1d;
export const VENDORS = [
  { vendorId: 0x04b8, name: "Epson" }, { vendorId: 0x0dd4, name: "Custom" }, { vendorId: 0x0fe6, name: "RCH / ICS" },
  { vendorId: 0x0416, name: "Xprinter / Winbond" }, { vendorId: 0x0483, name: "STMicro (Custom/RCH)" }, { vendorId: 0x1504, name: "Bixolon" },
  { vendorId: 0x0519, name: "Star Micronics" }, { vendorId: 0x1fc9, name: "NXP (POS)" }, { vendorId: 0x28e9, name: "GD32 (Xprinter)" },
  { vendorId: 0x1a86, name: "QinHeng (CH340 POS)" }, { vendorId: 0x067b, name: "Prolific (POS)" }, { vendorId: 0x6868, name: "Goojprt" }, { vendorId: 0x0525, name: "Netchip (POS)" },
];
const BT_SERVICES = ["000018f0-0000-1000-8000-00805f9b34fb", "e7810a71-73ae-499d-8c15-faa9aef0c3f2", "49535343-fe7d-4ae5-8fa9-9fafd205e455"];

export const printerSupport = () => ({ usb: !!navigator.usb, bluetooth: !!navigator.bluetooth });
const migrate = (c) => (c && c.kind && !c.printers ? { autoStaff: c.autoStaff, autoCustomer: c.autoCustomer, width: c.width, printers: { kitchen: { kind: c.kind, vendorId: c.vendorId, productId: c.productId, serial: c.serial, btId: c.btId, label: c.label } } } : c);
export const getPrinterConfig = () => { try { return migrate(JSON.parse(localStorage.getItem(KEY))) || null; } catch { return null; } };
export const savePrinterConfig = (cfg) => localStorage.setItem(KEY, JSON.stringify(cfg));
export const clearPrinterConfig = () => localStorage.removeItem(KEY);
export const STATIONS = { kitchen: "Cucina", bar: "Bar" };

const enc = (s) => {
  const map = { "à": 0x85, "è": 0x8a, "é": 0x82, "ì": 0x8d, "ò": 0x95, "ù": 0x97, "€": 0xd5, "°": 0xf8 };
  return Uint8Array.from([...String(s ?? "")].map((c) => map[c] ?? (c.charCodeAt(0) < 128 ? c.charCodeAt(0) : 0x3f)));
};
const cat = (...parts) => { const n = parts.reduce((s, p) => s + p.length, 0); const out = new Uint8Array(n); let o = 0; for (const p of parts) { out.set(p, o); o += p.length; } return out; };
const B = (...b) => Uint8Array.from(b);
const line = (s) => cat(enc(s), B(0x0a));
const money = (v, cur = "EUR") => `${Number(v).toFixed(2).replace(".", ",")} ${cur === "€" ? "EUR" : cur}`;
const lr = (l, r, w) => { const gap = Math.max(1, w - l.length - r.length); return l.slice(0, w - r.length - 1) + " ".repeat(gap) + r; };
const wrap = (s, w) => { const words = s.split(" "); const out = []; let cur = ""; for (const wd of words) { if ((cur + " " + wd).trim().length > w) { out.push(cur.trim()); cur = wd; } else cur = (cur + " " + wd); } if (cur.trim()) out.push(cur.trim()); return out; };

export function buildTicket(order, restaurantName = "", width = 80, stationLabel = "") {
  const W = width === 58 ? 32 : 48;
  const when = order.created_at ? new Date(order.created_at).toLocaleString("it-IT", { timeZone: "Europe/Rome", hour: "2-digit", minute: "2-digit", day: "2-digit", month: "2-digit" }) : "";
  const dash = line("-".repeat(W));
  const parts = [B(ESC, 0x40), B(ESC, 0x74, 0x10), B(ESC, 0x61, 0x01), B(ESC, 0x45, 0x01), line((restaurantName || "COMANDA").toUpperCase()), B(ESC, 0x45, 0x00)];
  if (stationLabel) parts.push(B(GS, 0x21, 0x01), line(stationLabel.toUpperCase()), B(GS, 0x21, 0x00));
  parts.push(line(`Ordine #${order.order_no} - ${when}`), B(GS, 0x21, 0x11));
  if (order.type === "takeaway") {
    const deliv = order.fulfillment === "delivery";
    parts.push(line(`${deliv ? "CONSEGNA" : "ASPORTO"} ${order.pickup_time || ""}`), B(GS, 0x21, 0x00), line(`${order.customer_name || ""} ${order.customer_surname || ""} ${order.phone || ""}`.trim()));
    if (deliv && order.address_line) parts.push(B(ESC, 0x45, 0x01), ...wrap(order.address_line, W).map(line), B(ESC, 0x45, 0x00));
    if (order.paid_online) parts.push(B(ESC, 0x45, 0x01), line("*** PAGATO ONLINE ***"), B(ESC, 0x45, 0x00));
    else if (order.source !== "staff") parts.push(line(deliv ? "Paga alla consegna" : "Paga al ritiro"));
  }
  else parts.push(line(`TAVOLO ${order.table || "-"}`), B(GS, 0x21, 0x00), ...(order.customer_name ? [line(order.customer_name)] : []));
  parts.push(B(ESC, 0x61, 0x00), dash);
  for (const it of order.items || []) {
    const name = `${it.quantity}x ${it.name}${it.variant ? ` (${it.variant})` : ""}`;
    const price = money(it.unit_price * it.quantity, order.currency);
    const rows = wrap(name, W - price.length - 1);
    parts.push(B(ESC, 0x45, 0x01), line(lr(rows[0], price, W)), ...rows.slice(1).map((r) => line("   " + r)), B(ESC, 0x45, 0x00));
    if (it.options?.length) parts.push(...wrap("   " + it.options.join(", "), W).map(line));
    if (it.notes) parts.push(...wrap("   >> " + it.notes, W).map(line));
  }
  parts.push(dash);
  if (order.notes) parts.push(...wrap("NOTE: " + order.notes, W).map(line), dash);
  const fee = Number(order.delivery_fee || 0);
  if (fee > 0) parts.push(line(lr("Consegna", money(fee, order.currency), W)));
  parts.push(B(GS, 0x21, 0x11), line(lr("TOTALE", money((order.items || []).reduce((s, i) => s + i.unit_price * i.quantity, 0) + fee, order.currency), Math.floor(W / 2))), B(GS, 0x21, 0x00));
  if (order.payment === "cassa" || order.source === "staff") parts.push(B(ESC, 0x61, 0x01), line("Pagamento alla cassa"), B(ESC, 0x61, 0x00));
  parts.push(B(0x0a, 0x0a, 0x0a), B(GS, 0x56, 0x42, 0x00));
  return cat(...parts);
}

// ---- USB ----
async function usbOpen(dev) {
  if (!dev.opened) await dev.open();
  if (dev.configuration === null) await dev.selectConfiguration(1);
  for (const iface of dev.configuration.interfaces) {
    const alt = iface.alternates[0];
    const ep = alt.endpoints.find((e) => e.direction === "out" && e.type === "bulk");
    if (ep) { try { await dev.claimInterface(iface.interfaceNumber); } catch { continue; } return ep.endpointNumber; }
  }
  throw new Error("Nessuna interfaccia di stampa trovata sul dispositivo");
}
export async function pairUsbPrinter() {
  const dev = await navigator.usb.requestDevice({ filters: [...VENDORS.map((v) => ({ vendorId: v.vendorId })), { classCode: 7 }] });
  await usbOpen(dev);
  const vendor = VENDORS.find((v) => v.vendorId === dev.vendorId)?.name || dev.manufacturerName || "Stampante";
  return { kind: "usb", vendorId: dev.vendorId, productId: dev.productId, serial: dev.serialNumber || "", label: `${vendor} ${dev.productName || ""}`.trim() };
}
async function usbFind(cfg) {
  const devs = await navigator.usb.getDevices();
  return devs.find((d) => d.vendorId === cfg.vendorId && d.productId === cfg.productId && (!cfg.serial || d.serialNumber === cfg.serial)) || null;
}
async function usbSend(cfg, data) {
  const dev = await usbFind(cfg);
  if (!dev) throw new Error("Stampante USB non collegata: verifica il cavo e ricollegala dalle Impostazioni");
  const ep = await usbOpen(dev);
  for (let i = 0; i < data.length; i += 4096) await dev.transferOut(ep, data.slice(i, i + 4096));
}

// ---- Bluetooth ----
const btChars = {};
export async function pairBluetoothPrinter() {
  const dev = await navigator.bluetooth.requestDevice({ acceptAllDevices: true, optionalServices: BT_SERVICES });
  await btConnect(dev);
  return { kind: "bluetooth", btId: dev.id, label: dev.name || "Stampante Bluetooth" };
}
async function btConnect(dev) {
  const server = await dev.gatt.connect();
  for (const s of BT_SERVICES) {
    try {
      const svc = await server.getPrimaryService(s);
      const chars = await svc.getCharacteristics();
      const c = chars.find((x) => x.properties.write || x.properties.writeWithoutResponse);
      if (c) { btChars[dev.id] = c; return c; }
    } catch { /* prova il servizio successivo */ }
  }
  throw new Error("La stampante Bluetooth non espone un servizio di stampa compatibile");
}
async function btSend(cfg, data) {
  let ch = btChars[cfg.btId];
  if (!ch || !ch.service.device.gatt.connected) {
    const devs = navigator.bluetooth.getDevices ? await navigator.bluetooth.getDevices() : [];
    const dev = devs.find((d) => d.id === cfg.btId);
    if (!dev) throw new Error("Stampante Bluetooth non trovata: ricollegala dalle Impostazioni");
    ch = await btConnect(dev);
  }
  const chunk = 100;
  for (let i = 0; i < data.length; i += chunk) {
    const part = data.slice(i, i + chunk);
    if (ch.properties.writeWithoutResponse) await ch.writeValueWithoutResponse(part); else await ch.writeValue(part);
  }
}

async function sendTo(p, data) {
  if (!p?.kind) throw new Error("Nessuna stampante collegata");
  if (p.kind === "usb") return usbSend(p, data);
  return btSend(p, data);
}
export const configuredStations = () => Object.entries(getPrinterConfig()?.printers || {}).filter(([, p]) => p?.kind).map(([k]) => k);
export const isPrinterConfigured = () => configuredStations().length > 0;

// Divide i piatti fra cucina e bar; se manca una stampante, tutto va su quella disponibile
export function splitByStation(items, stations) {
  const hasK = stations.includes("kitchen"), hasB = stations.includes("bar");
  if (!hasK && !hasB) return {};
  const g = { kitchen: [], bar: [] };
  for (const it of items) { const st = it.station || "kitchen"; for (const t of (st === "both" ? ["kitchen", "bar"] : [st])) g[t].push(it); }
  if (!hasB) return { kitchen: [...g.kitchen, ...g.bar.filter((i) => !g.kitchen.includes(i))] };
  if (!hasK) return { bar: [...g.bar, ...g.kitchen.filter((i) => !g.bar.includes(i))] };
  return Object.fromEntries(Object.entries(g).filter(([, v]) => v.length));
}

export async function printTicket(order, restaurantName) {
  const cfg = getPrinterConfig();
  const stations = configuredStations();
  const groups = splitByStation(order.items || [], stations);
  const errors = [];
  for (const [st, items] of Object.entries(groups)) {
    try { await sendTo(cfg.printers[st], buildTicket({ ...order, items }, restaurantName, cfg.width || 80, stations.length > 1 ? STATIONS[st] : "")); }
    catch (e) { errors.push(`${STATIONS[st]}: ${e.message}`); }
  }
  if (errors.length) throw new Error(errors.join(" · "));
}
export const printTestStation = (station, restaurantName) => sendTo(getPrinterConfig()?.printers?.[station], buildTicket({ order_no: "TEST", table: "Prova", created_at: new Date().toISOString(), currency: "€",
  items: [{ name: `Stampa di prova ${STATIONS[station]}`, quantity: 1, unit_price: 0 }], notes: "Se leggi questo, la stampante e' pronta." }, restaurantName, getPrinterConfig()?.width || 80, STATIONS[station]));
